/* eslint-disable @typescript-eslint/no-unused-vars */

import ManagerRepository from 'coreClasses/ManagerRepository';
import componentsBuilder from './componentsBuilder';

/**
 * Represents CMSProvider
 */
class CMSProvider {
	protected managerRepository: ManagerRepository;

	/**
	 * @constructor
	 * @param managerRepository {ManagerRepository} - ManagerRepository instance
	 */
	constructor(managerRepository: ManagerRepository) {
		this.managerRepository = managerRepository;
	}

	/**
	 * Returns provider ID
	 */
	getId(): string {
		return 'CMSProvider';
	}

	/**
	 * Returns content
	 * @param {String} id Content Id
	 * @param {Object} config Additional config
	 * @param {Boolean} isMultiContent If yes returns an array of results
	 * @param oldLogic // Temporary, will be removed
	 * @returns {Promise}
	 */
	async getContent(
		id,
		config = {},
		isMultiContent = false,
		oldLogic = true
	) {
		return null;
	}

	/**
	 * Returns backed up content
	 * @param {String} id Content Id
	 * @returns {Content|null}
	 */
	async getBackupContent(id) {
		let {data} = await this.managerRepository.getSfccAPI().getCMSBackupData({
			id,
		});

		try {
			data = JSON.parse(data);
			// eslint-disable-next-line no-empty
		} catch {}

		return data;
	}

	/**
	 * Returns Components Builder
	 * @returns {ComponentsBuilder}
	 */
	getBuilder(): unknown {
		return componentsBuilder;
	}

	/**
	 * Returns API Client state
	 * @returns {Object}
	 */
	getAPIClientState() {
		return null;
	}

	/**
	 * Sets API Client state
	 * @param {Object} state State to restore
	 */
	setAPIClientState(state) {}

	/**
	 * Has CMS a preview widget?
	 * @returns {boolean} true if CMS has preview widget, false otherwise
	 */
	hasPreviewWidget() {
		return false;
	}
}

export default CMSProvider;
